module.exports = __webpack_public_path__ + "static/27-a87dce85eae042b49ff67e4bc4f884cc.jpg";